import * as React from 'react';
import PropTypes from 'prop-types';
import {
  GridToolbarDensitySelector,
  GridToolbarFilterButton
} from '@mui/x-data-grid-premium';
import { createTheme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(0.5, 0.5, 0),
      justifyContent: 'space-between',
      display: 'flex',
      alignItems: 'flex-start',
      flexWrap: 'wrap'
    },
  }),
  { defaultTheme, index: 1 }
);

const QuickSearchToolbar = (props) => {
  const customClasses = useStyles();
  const { additionalComponents } = props;
  return (
    <div className={customClasses.root}>
      <div>
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        {Array.isArray(additionalComponents) ? additionalComponents.map(r => r) : additionalComponents}
      </div>
    </div>
  );
};

QuickSearchToolbar.propTypes = {
  additionalComponents: PropTypes.arrayOf(PropTypes.any)
};
QuickSearchToolbar.defaultProps = {
  additionalComponents: null
};


export default QuickSearchToolbar;
